export const visitBanner = {
  title: "Ne restez pas avec des doutes !",
  description: "Réservez votre visite le jour et l'heure que vous souhaitez et découvrez comment nous fonctionnons.",
  button: "Réserver une visite"
};
